// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dadata-service-error[data-v-710fef7b]{opacity:.6}`, "",{"version":3,"sources":["webpack://./lib/vue/address/dadata.vue"],"names":[],"mappings":"AACA,uCACE,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
